var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row flex-align-center"},[_c('span',{staticClass:"contact-img"},[_c('img',{attrs:{"src":_vm.item.avatar_url,"alt":""}})]),_c('span',{staticClass:"contact-name"},[_vm._v(_vm._s(_vm.item.nick_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }